import React, { useState } from 'react'
import LandingView from '../components/LandingView/LandingView'
import LevelSelection from '../components/LevelSelection/LevelSelection'
import SceneWrapper from '../components/SceneWrapper'
import SVG from 'react-inlinesvg'
import taniko from '../assets/taniko.svg'
import banner from '../assets/banner.svg'

function IndexPage () {
  const [showLandingScreen, setShowLandingScreen] = useState(true)
  const [showLevelSelectScreen, setShowLevelSelectScreen] = useState(false)
  const [showCanvas, setShowCanvas] = useState(false)
  const [backgroundClass, setBackgroundClass] = useState('bg-grad-blue')
  const [canvasClass, setCanvasClass] = useState('opacity-0')

  const handleStartClick = () => {
    // Temporarily we are going to avoid the level select screen and jump right to the hall
    setTimeout(() => handleLevelSelect('hall'), 500)
    // setShowLevelSelectScreen(true)
    setBackgroundClass('bg-primary-lightBlue')
    setTimeout(() => {
      setShowLandingScreen(false)
    }, 1000)
  }

  const handleLevelSelect = (r: string) => {
    window.history.pushState({}, '', r)
    setBackgroundClass('bg-transparent')
    setShowCanvas(true)
    setTimeout(() => {
      setShowLevelSelectScreen(false)
      setCanvasClass('animation-fadeIn')
    }, 500)
  }

  return (
    <div className="App">
      <div className={'overflow-hidden absolute inset-0'}>
        <SVG src={taniko} className={'w-0 h-0'} />
        <SVG src={banner} className={'w-full absolute left-0 top-0 h-[calc(100%+18.75rem)] text-[#d7f8ff] z-[-1]'} />
      </div>
      <div className={'w-full h-body relative ' + backgroundClass}>
        {showLandingScreen && <LandingView startCallback={handleStartClick} />}
        {showLevelSelectScreen && <LevelSelection onSelection={handleLevelSelect} />}
        {showCanvas &&
          <div className={'w-full h-body relative ' + canvasClass}>
            <SceneWrapper />
          </div>}
      </div>
    </div>
  )
}

export default IndexPage
